import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Typo } from 'tmt-ui-kit';
import styled from 'styled-components';
import Router from 'next/router';
import { connect } from 'react-redux';

import HeadTag from '~/components/Head/HeadTag';
import MenuItem from '~/components/HelpCenter/MenuItem';
import BannerHelp from '~/components/HelpCenter/BannerHelp';
import Bredcrumb from '~/components/HelpCenter/Bredcrumb';
import ContactUs from '~/components/HelpCenter/ContactUs';
import { actions as sessionActions } from '~/redux/reducers/session';
import HelpCenterData from '~/utils/help-center';
import NotFound from '~/components/NotFound/NotFound';

const DesktopContent = styled.div`
  display: flex;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
const MenuContainer = styled.div`
  margin-top: 16px;
  @media screen and (min-width: 601px) {
    min-width: 214px;
  }
`;
const Header = styled(Typo.HeaderTwo)`
  font-size: 20px;
  text-transform: capitalize;
  font-weight: 500 !important;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 0px !important;
  color: ${props => props.theme.black};
`;
const MenuListContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;
const MenuText = styled.div`
  ${props => props.isShowSub && 'display: none;'}
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  white-space: warp;
  letter-spacing: normal;
  color: ${props => (props.active ? props.theme.blue : props.theme.black)};
  cursor: pointer;
`;
const VerticalHR = styled.hr`
  margin-top: 48px;
  margin-right: 64px;
  margin-left: 40px;
  height: auto;
  border-left: 2px solid ${props => props.theme.blueGray};

  @media screen and (max-width: 768px) {
    margin-right: 48px;
    margin-left: 0px;
  }
  @media screen and (max-width: 600px) {
    display: none;
  }
`;
const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const HelpContainer = styled.div`
  margin-bottom: 40px;
`;
const Subtitle = styled.p`
  padding-left: 16px;
`;

const enhance = connect(
  null,
  { ...sessionActions }
);

class HelpCenter extends Component {
  static propTypes = {
    url: PropTypes.any,
    logFromCancellationPolicyModal: PropTypes.func
  };

  constructor(props) {
    super(props);
    const { url } = this.props;
    const titleQuery = url.query.slug ? url.query.slug : url.query.type;
    const objName = titleQuery.replace('-', '');
    const contents = HelpCenterData[objName];
    const queryTopic = url.query.topic && url.query.topic;
    const querySubtitle = url.query.subtitle;
    let toggleId = 0;
    let subToggleId = 0;
    let title = '';
    if (contents) {
      contents.map((c, index) => {  // eslint-disable-line
        if (c.title === queryTopic) {
          toggleId = index;
          title = c.title; // eslint-disable-line
        }
        if (url.query && url.query.subtitle) {
          if (c.subTitle) {
            c.subTitle.map((sub, indexSub) => { // eslint-disable-line
              if (sub.title === querySubtitle) {
                subToggleId = indexSub;
              }
            });
          }
        }
      });
    }
    this.state = {
      topic: titleQuery,
      title,
      subtitle: '',
      toggleId,
      subToggleId,
      contentIndex: this.props.url.query && this.props.url.query.index
    };
    this.isNotFound = this.isNotFound.bind(this);
    this.onClickTopic = this.onClickTopic.bind(this);
    this.onClickSetContentIndex = this.onClickSetContentIndex.bind(this);
  }

  componentDidMount() {
    const { url } = this.props;
    if (url.query && url.query.source === 'cancellation-modal' && url.query.type === 'local-expert') {
      this.props.logFromCancellationPolicyModal();
      Router.replace({
        pathname: '/help-center/help',
        query: { slug: 'local-expert', topic: url.query.topic },
      }, '/help-center/local-expert', { shallow: true });
    }
  }

  onClickTopic(index, indexSub, title, subtitle) {
    this.setState({
      toggleId: index,
      subToggleId: indexSub,
      title,
      subtitle: subtitle !== '' ? subtitle : '',
      contentIndex: null
    });
    Router.replace({
      pathname: '/help-center/help',
      query: { slug: this.state.topic, topic: title },
    }, `/help-center/${this.state.topic}?topic=${title}${subtitle ? `&subtitle=${subtitle}` : ''}`, { shallow: true });
  }

  onClickSetContentIndex(index) { // eslint-disable-line
    const { subtitle, title, topic } = this.state;
    Router.replace({
      pathname: '/help-center/help',
      query: { slug: topic, topic: title, subtitle },
    }, `/help-center/${topic}?topic=${title}${subtitle ? `&subtitle=${subtitle}` : ''}&index=${index}`, { shallow: true });
    this.setState({ contentIndex: index });
  }

  isNotFound(query) { // eslint-disable-line
    if (query === 'traveler' || query === 'local-expert') return false;
    return true;
  }

  render() {
    const { toggleId, subToggleId, contentIndex } = this.state;
    const { url } = this.props;
    const title = url.query.slug ? url.query.slug : url.query.type;
    const dataName = title.replace('-', '');
    const contents = HelpCenterData[dataName];
    if (this.isNotFound(title)) return <NotFound />;
    return (
      <Fragment>
        <HeadTag
          title={this.state.title !== '' ? this.state.title : 'Account Settings'}
        />
        <HelpContainer>
          <BannerHelp />
          <Container.InnerContainer>
            <Bredcrumb title={title.replace('-', ' ')}/>
            <DesktopContent>
              <MenuContainer>
                <Header>{title.replace('-', ' ')}</Header>
                <MenuListContainer>
                  {contents && (
                    contents.map((c, index) => {  // eslint-disable-line
                      return (
                        <div key={c.title + index}>
                          <MenuText
                            key={c.title}
                            active={index === toggleId}
                            onClick={() => this.onClickTopic(index, 0, c.title, c.subTitle && c.subTitle[0].title)}
                          >
                            {c.title}
                          </MenuText>
                          {c.subTitle && c.subTitle.map((sub, indexSub) => (
                            <MenuText
                              key={sub.title + indexSub}
                              isShowSub={index !== toggleId}
                              active={indexSub === subToggleId}
                              onClick={() => this.onClickTopic(index, indexSub, c.title, sub.title)}
                            >
                              <Subtitle>{sub.title}</Subtitle>
                            </MenuText>
                          ))}
                        </div>
                      );
                    })
                  )}
                </MenuListContainer>
              </MenuContainer>
              <VerticalHR />
              <MenuItemContainer>
                <MenuItem
                  contentIndex={contentIndex}
                  key={toggleId}
                  data={contents[toggleId]}
                  subToggleId={this.state.subToggleId}
                  onClickSetContentIndex={this.onClickSetContentIndex}
                />
                <ContactUs />
              </MenuItemContainer>
            </DesktopContent>
          </Container.InnerContainer>
        </HelpContainer>
      </Fragment>
    );
  }
}

export default enhance(HelpCenter);
